var _defs, _ellipse, _text, _ellipse2, _text2, _ellipse3, _text3, _ellipse4, _text4, _ellipse5, _text5, _ellipse6, _text6, _path, _path2, _path3, _path4, _rect, _text7, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphdrawio6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "391px",
    height: "231px",
    viewBox: "-0.5 -0.5 391 231",
    className: "ge-export-svg-dark",
    content: "<mxfile host=\"Electron\" modified=\"2024-02-10T11:38:58.887Z\" agent=\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/22.1.16 Chrome/120.0.6099.109 Electron/28.1.0 Safari/537.36\" etag=\"IU9_dOOSNLbNVdqONWO6\" version=\"22.1.16\" type=\"device\"><diagram name=\"Page-1\" id=\"beBrEWIuwQJhH1_dIsJB\">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</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(24, 20, 29)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "svg.ge-export-svg-dark &gt; * { filter: invert(100%) hue-rotate(180deg); }&#xa;svg.ge-export-svg-dark image { filter: invert(100%) hue-rotate(180deg) }"))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 50,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 50,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 54,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 190,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 190,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "6")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 194,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "6")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 100,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 100,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "5")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "5")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "3")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "3")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2")))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 20,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 20,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "4")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 24,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "4")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 79.9 65.97 L 76.25 68.94 L 73.58 70.84 L 70.62 72.66 L 67.31 74.49 L 63.7 76.31 L 59.93 78.12 L 56.34 79.78 L 52.83 81.38 L 49.22 83.08 L 45.72 84.89 L 42.43 86.79 L 39.49 88.84 L 36.79 91.13 L 34.39 93.6 L 32.31 96.12 L 30.64 98.53 L 29.64 100.7 L 29.04 102.8 L 28.67 104.83 L 28.47 106.67 L 28.31 109.53 L 28.35 111.79 L 28.44 113.69 L 28.54 116.14 L 28.58 118.71 L 28.49 119.26 L 28.23 119.75 L 27.83 120.13 L 27.32 120.36 L 26.77 120.42 L 26.23 120.3 L 25.75 120.02 L 25.4 119.6 L 25.19 119.08 L 25.16 118.52 L 25.31 117.99 L 25.62 117.53 L 26.06 117.2 L 26.59 117.02 L 27.14 117.02 L 27.67 117.2 L 28.11 117.53 L 28.42 117.99 L 28.56 118.52 L 28.54 119.08 L 28.33 119.6 L 27.97 120.02 L 27.5 120.3 L 26.96 120.42 L 26.4 120.36 L 25.9 120.13 L 25.49 119.75 L 25.24 119.26 L 25.15 118.71 L 25.15 118.71 L 25.18 116.14 L 25.3 113.68 L 25.4 111.74 L 25.59 109.27 L 26.04 106.29 L 26.42 104.34 L 26.98 102.12 L 27.84 99.8 L 29.13 97.44 L 30.96 94.99 L 33.15 92.39 L 35.67 89.8 L 38.49 87.43 L 41.56 85.28 L 44.93 83.35 L 48.47 81.51 L 52.11 79.78 L 55.6 78.18 L 59.16 76.51 L 62.89 74.7 L 66.42 72.89 L 69.63 71.09 L 72.47 69.26 L 75.04 67.48 L 78.65 64.45 L 78.85 64.32 L 79.07 64.25 L 79.31 64.22 L 79.54 64.26 L 79.76 64.35 L 79.95 64.49 L 80.1 64.67 L 80.21 64.89 L 80.26 65.12 L 80.25 65.36 L 80.18 65.58 L 80.07 65.79 L 79.9 65.97 L 79.9 65.97",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 108.67 57.99 L 110.15 58.59 L 112.11 59.46 L 114.64 60.88 L 116.16 61.98 L 117.73 63.2 L 119.44 64.66 L 121.15 66.27 L 122.95 68.09 L 124.75 70.11 L 126.64 72.45 L 128.56 74.84 L 130.41 77.21 L 132.15 79.69 L 133.68 82.1 L 135.17 84.57 L 136.56 87.13 L 137.84 89.72 L 138.95 92.12 L 139.82 94.41 L 140.59 96.72 L 141.29 98.94 L 141.99 101.16 L 142.69 103.39 L 143.39 105.51 L 144.13 107.7 L 144.82 109.84 L 145.58 112 L 146.4 114.14 L 147.25 116.24 L 148.03 118.24 L 148.78 120 L 149.53 121.7 L 150.67 124.4 L 150.73 124.73 L 150.68 125.07 L 150.53 125.37 L 150.29 125.62 L 149.98 125.77 L 149.65 125.81 L 149.31 125.74 L 149.01 125.57 L 148.79 125.32 L 148.66 125.01 L 148.63 124.67 L 148.72 124.33 L 148.9 124.05 L 149.17 123.84 L 149.49 123.72 L 149.83 123.72 L 150.16 123.82 L 150.43 124.02 L 150.63 124.3 L 150.72 124.63 L 150.71 124.97 L 150.59 125.28 L 150.38 125.54 L 150.09 125.73 L 149.76 125.81 L 149.42 125.77 L 149.11 125.64 L 148.86 125.41 L 148.69 125.12 L 148.69 125.12 L 147.7 122.47 L 146.99 120.71 L 146.3 118.9 L 145.57 116.91 L 144.72 114.79 L 143.89 112.59 L 143.1 110.37 L 142.46 108.26 L 141.73 106.05 L 141.06 103.89 L 140.39 101.65 L 139.73 99.41 L 139.1 97.2 L 138.39 94.92 L 137.64 92.71 L 136.57 90.36 L 135.3 87.82 L 133.93 85.33 L 132.43 82.91 L 130.9 80.58 L 129.17 78.2 L 127.28 75.9 L 125.3 73.59 L 123.36 71.41 L 121.53 69.57 L 119.69 67.91 L 117.98 66.45 L 116.27 65.12 L 114.73 63.98 L 113.34 63.01 L 111.04 61.62 L 109.28 60.66 L 107.81 60.01 L 107.59 59.88 L 107.4 59.69 L 107.25 59.47 L 107.17 59.22 L 107.15 58.96 L 107.19 58.7 L 107.29 58.45 L 107.45 58.24 L 107.65 58.08 L 107.89 57.96 L 108.15 57.91 L 108.42 57.92 L 108.67 57.99 L 108.67 57.99",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.28 136.49 L 41.2 136.5 L 43.81 136.43 L 45.27 136.4 L 46.82 136.44 L 48.38 136.5 L 50.19 136.64 L 52.11 136.82 L 54.1 137.01 L 56.23 137.22 L 58.56 137.45 L 61.09 137.69 L 63.68 137.88 L 66.51 138.05 L 69.39 138.14 L 72.6 138.2 L 76.09 138.23 L 80.15 138.26 L 84.7 138.27 L 89.52 138.28 L 94.49 138.34 L 99.43 138.42 L 104.25 138.5 L 108.79 138.64 L 112.96 138.79 L 116.41 138.96 L 119.48 139.18 L 122.18 139.42 L 124.66 139.59 L 126.81 139.72 L 128.72 139.83 L 130.49 139.95 L 132.17 140.07 L 133.85 140.2 L 136.29 140.32 L 138.61 140.42 L 140.02 140.53 L 142.67 140.69 L 145.44 140.85 L 148.39 141.09 L 148.81 141.18 L 149.16 141.4 L 149.43 141.72 L 149.59 142.12 L 149.61 142.54 L 149.5 142.95 L 149.26 143.29 L 148.92 143.55 L 148.52 143.68 L 148.09 143.68 L 147.69 143.54 L 147.36 143.29 L 147.12 142.94 L 147.01 142.53 L 147.03 142.11 L 147.2 141.72 L 147.47 141.39 L 147.84 141.18 L 148.25 141.09 L 148.67 141.14 L 149.05 141.31 L 149.35 141.61 L 149.55 141.98 L 149.62 142.4 L 149.55 142.81 L 149.35 143.19 L 149.04 143.48 L 148.66 143.65 L 148.24 143.7 L 148.24 143.7 L 145.25 143.43 L 143.81 143.31 L 141.13 143.09 L 138.44 142.79 L 136.09 142.53 L 133.63 142.2 L 131.99 141.98 L 130.3 141.76 L 128.56 141.52 L 126.68 141.29 L 124.54 141.04 L 122.05 140.81 L 119.38 140.56 L 116.35 140.35 L 112.9 140.18 L 108.76 140.03 L 104.23 139.9 L 99.4 139.82 L 94.48 139.76 L 89.52 139.72 L 84.7 139.73 L 80.15 139.74 L 76.09 139.75 L 72.59 139.77 L 69.36 139.79 L 66.46 139.8 L 63.59 139.77 L 60.96 139.71 L 58.41 139.61 L 56.06 139.49 L 53.9 139.36 L 51.91 139.23 L 50.01 139.1 L 48.25 138.98 L 46.74 138.9 L 45.27 138.84 L 43.81 138.82 L 41.2 138.75 L 39.28 138.75 L 39 138.72 L 38.76 138.62 L 38.52 138.47 L 38.34 138.26 L 38.22 138.02 L 38.15 137.76 L 38.15 137.48 L 38.22 137.22 L 38.34 136.98 L 38.52 136.78 L 38.76 136.62 L 39 136.52 L 39.28 136.49 L 39.28 136.49",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 324.38 32.24 L 325.44 34.12 L 326.98 36.35 L 327.83 37.59 L 328.73 38.83 L 329.67 40.17 L 330.66 41.57 L 331.74 43.11 L 332.9 44.85 L 334.18 46.66 L 335.51 48.48 L 336.84 50.18 L 338.28 52.02 L 339.73 53.85 L 341.11 55.69 L 342.35 57.36 L 343.49 58.84 L 344.5 60.22 L 345.49 61.59 L 346.47 62.95 L 347.36 64.3 L 348.24 65.66 L 349.17 66.91 L 350.21 68.29 L 351.26 69.68 L 352.26 71.01 L 353.2 72.27 L 354.1 73.5 L 355.68 75.53 L 356.91 77.27 L 357.87 78.69 L 358.71 80.16 L 359.92 82.28 L 360.07 82.72 L 360.07 83.18 L 359.93 83.63 L 359.65 84 L 359.27 84.27 L 358.82 84.4 L 358.35 84.38 L 357.92 84.21 L 357.56 83.91 L 357.32 83.51 L 357.21 83.06 L 357.26 82.6 L 357.45 82.17 L 357.77 81.83 L 358.17 81.61 L 358.63 81.53 L 359.1 81.6 L 359.51 81.81 L 359.83 82.14 L 360.03 82.57 L 360.09 83.03 L 360 83.48 L 359.76 83.89 L 359.41 84.19 L 358.97 84.37 L 358.51 84.4 L 358.06 84.28 L 357.67 84.02 L 357.38 83.66 L 357.38 83.66 L 355.87 80.8 L 355.12 79.44 L 354.21 77.94 L 352.93 76.07 L 352.12 74.93 L 351.25 73.69 L 350.35 72.43 L 349.37 71.09 L 348.34 69.7 L 347.27 68.28 L 346.29 66.89 L 345.45 65.53 L 344.64 64.21 L 343.71 62.82 L 342.78 61.43 L 341.86 60.05 L 340.76 58.53 L 339.55 56.87 L 338.2 55.09 L 336.71 53.29 L 335.2 51.5 L 333.79 49.77 L 332.39 47.98 L 330.99 46.16 L 329.81 44.51 L 328.68 42.96 L 327.68 41.55 L 326.77 40.22 L 325.86 38.91 L 325.05 37.66 L 324.25 36.42 L 323.54 35.21 L 322.44 33.35 L 322.34 33.1 L 322.3 32.84 L 322.32 32.57 L 322.4 32.31 L 322.55 32.08 L 322.74 31.9 L 322.98 31.76 L 323.24 31.69 L 323.51 31.68 L 323.77 31.73 L 324.01 31.85 L 324.22 32.02 L 324.38 32.24 L 324.38 32.24",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 200,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 215,
      marginLeft: 115
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "RES:3")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 219,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "RES:3"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphdrawio6);
export default __webpack_public_path__ + "static/media/graph.drawio6.9b70569b80d45613de2137240d83e3b9.svg";
export { ForwardRef as ReactComponent };